import moment from "moment";
import { ValueStrings } from "./constantsString";
import { getItemSession } from "../utils/session";
import { UNITS } from "../constants/globalStrings";

let currentPlantId;

export const updatePlantId = (plantId) => {
  if (plantId !== undefined) currentPlantId = plantId;
};

export const extractPlantId = () => {
  if (currentPlantId) {
    return currentPlantId;
  } else {
    var lastVisitedURL = getItemSession("lastVisitedURL");
    if (lastVisitedURL) {
      var searchParams = new URLSearchParams(lastVisitedURL.split("?")[1]);
      const plantId = searchParams.get("plantId");
      updatePlantId(plantId);
      return plantId;
    }
  }
};

export const loadExternalScript = (url) => {
  if (url) {
    const script = document.createElement("script");
    script.src = url;
    document.body.appendChild(script);
  }
};

export const getDuplicateItems = (array) => {
  const seen = new Set();
  const duplicates = [];

  for (const item of array) {
    const itemString = JSON.stringify(item);

    if (
      seen.has(itemString) &&
      !duplicates.some((dup) => JSON.stringify(dup) === itemString)
    ) {
      duplicates.push(item);
    } else {
      seen.add(itemString);
    }
  }
  duplicates.sort((a, b) => {
    if (!a && !b) {
      return 0;
    } else if (!a) {
      return 1;
    } else if (!b) {
      return -1;
    } else {
      return new Date(a) - new Date(b);
    }
  });
  return duplicates;
};

export const getCurrencySymbol = {
  USD: "$",
  Yuan: "元",
  Euro: "€",
};

export const getControlId = (text = "dupont", cntrlType) => {
  const label = text
    .toLowerCase()
    .replace(/\s/g, "_", "_")
    .replace(/[^a-z0-9_]/g, "");
  return cntrlType ? `${label}_${cntrlType}` : label;
};

export const getChangedData = (updatedData, initialData) => {
  if (Array.isArray(updatedData) || updatedData === "") {
    return updatedData;
  }
  const dataDiff = {};
  for (const key in updatedData) {
    if (initialData) {
      if (initialData[key] !== null && typeof initialData[key] === "object") {
        dataDiff[key] = getChangedData(updatedData[key], initialData[key]);
        if (typeof dataDiff[key] === "object") {
          //need this remove && condition, BE to implement empty attribute
          if (Object.keys(dataDiff[key]).length === 0 && key !== "Attributes") {
            delete dataDiff[key];
          }
        }
      } else if (initialData[key] !== updatedData[key]) {
        dataDiff[key] = updatedData[key];
      }
    }
  }
  return dataDiff;
};

export const UpdateSetWithKey = (prevData, key, value) => {
  const updatedData = { ...prevData };
  updatedData[key] = value;
  return updatedData;
};

export const getFormattedDate = (dateString) => {
  const date = moment(dateString).isValid();
  return date ? moment(dateString).format(ValueStrings.dateFormat) : "";
};

export const getIndex = (params, column) => {
  return column ? params.node.rowIndex + 1 : "-";
};

export const combineClassNames = (...classes) =>
  classes.filter(Boolean).join(" ").trim();

export const formatNullValues = (params) => params.value ?? "-";

export const hasMetricValue = (value) => value != null && Number(value) !== 0;

export const formatDecimal = (value, decimalPlaces = 2) => {
  if (value === null || value === undefined || value === "") return value;
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return value;
  return numericValue.toFixed(decimalPlaces);
};


/**
 * Formats hours to days and hours when > 24 hours
 * @param {number} hours - The time in hours
 * @returns {string} Formatted string (e.g., "2 days, 2 hours" or "12.5 hours")
 */
export const formatOperationalTime = (hours) => {
  const parsedHours = Number(hours);
  if (!Number.isFinite(parsedHours)) return "";

  if (parsedHours < 24) {
    return `${parsedHours.toFixed(1)} ${UNITS.HOURS}`;
  }

  const days = Math.floor(parsedHours / 24);
  const dayLabel = days === 1 ? UNITS.DAYS.slice(0, -1) : UNITS.DAYS;
  const remainingHours = Number((parsedHours - days * 24).toFixed(1));

  if (remainingHours === 0) {
    return `${days} ${dayLabel}`;
  }

  const hourLabel =
    remainingHours === 1 ? UNITS.HOURS.slice(0, -1) : UNITS.HOURS;
  return `${days} ${dayLabel}, ${remainingHours.toFixed(1)} ${hourLabel}`;
};